import React from "react";
import Servicebannerpage from "./Servicebannerpage/Servicebannerpage";
import Servicestep from "./Servicestep/Servicestep";
import Whitesection from "./Whitesection/Whitesection";
import { Helmet } from "react-helmet-async";

const Service = () => {
  return (
    <>
      <Helmet>
        <title> IT & Cloud Solutions | Software, SAP, Staffing - Owision</title>
        <meta
          name="description"
          content="Discover Owision's comprehensive IT services, encompassing cloud solutions, SAP consulting, custom software development, staffing, and managed support, designed to drive global business success.
"
        />
      </Helmet>
      <section>
        <Servicebannerpage />
        <Servicestep />
        <Whitesection />
      </section>
    </>
  );
};

export default Service;
